'use strict';
import * as $j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dOriginal$002dDocument$002dWatermark$0024 from "./app.data.organization_types$package$-Organization-Original-Document-Watermark$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$() {
  this.aUJ = null;
  this.aV0 = null;
  this.aUM = null;
  this.aUN = false;
  this.aUS = null;
  this.aUT = false;
  this.aUY = null;
  this.aUZ = false;
  this.aUK = null;
  this.aUL = false;
  this.aUW = null;
  this.aUX = false;
  this.aUU = null;
  this.aUV = false;
  this.aUO = null;
  this.aUP = false;
  this.aUQ = null;
  this.aUR = false;
  $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ = this;
  this.aUJ = $j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dOriginal$002dDocument$002dWatermark$0024.$m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$();
  this.aV0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002eorganization$005ftypes$0024package$0024$002dOrganization$002dOriginal$002dDocument$002dWatermark$0024.$m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermark$());
}
export { $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ as $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ };
$p = $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$;
/** @constructor */
function $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$() {
}
export { $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ as $h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ };
$h_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$.prototype = $p;
$p.eR = (function() {
  return this.aUJ;
});
$p.eO = (function() {
  return this.aV0;
});
$p.bW = (function() {
  if ((!this.aUN)) {
    this.aUM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aUN = true;
  }
  return this.aUM;
});
$p.b9 = (function() {
  if ((!this.aUT)) {
    this.aUS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aUT = true;
  }
  return this.aUS;
});
$p.b3 = (function() {
  if ((!this.aUZ)) {
    this.aUY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aUZ = true;
  }
  return this.aUY;
});
$p.aG = (function() {
  if ((!this.aUL)) {
    this.aUK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aUL = true;
  }
  return this.aUK;
});
$p.az = (function() {
  if ((!this.aUX)) {
    this.aUW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aUX = true;
  }
  return this.aUW;
});
$p.aY = (function() {
  if ((!this.aUV)) {
    this.aUU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aUV = true;
  }
  return this.aUU;
});
$p.bNd = (function() {
  if ((!this.aUP)) {
    this.aUO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Original Document Watermark Text";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aUP = true;
  }
  return this.aUO;
});
$p.bNF = (function() {
  if ((!this.aUR)) {
    this.aUQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aUR = true;
  }
  return this.aUQ;
});
var $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$, "app.data.organization_types$package$OrganizationOriginalDocumentWatermarkForm$", ({
  GR: 1,
  N: 1
}));
export { $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ as $d_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ };
var $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$;
function $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$() {
  if ((!$n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$)) {
    $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ = new $c_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$();
  }
  return $n_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$;
}
export { $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ as $m_Lapp_data_organization\uff3ftypes$package$OrganizationOriginalDocumentWatermarkForm$ };
//# sourceMappingURL=app.data.organization_types$package$-Organization-Original-Document-Watermark-Form$.js.map
